<template>
  <div class="training-note">
    <Textarea
      v-model="activityDetailStoreRef.sportNote"
      class="training-note-input"
      :placeholder="$t('R9022')"
      :disabled="!isMyself"
    ></Textarea>
    <div
      v-if="isMyself"
      class="btn-group"
    >
      <Button
        :disabled="sportNote.length === 0 || oldSportNote === sportNote"
        @click="handleSave"
      >
        {{ $t('G1006') }}
      </Button>
    </div>
  </div>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue';
import { Button, Textarea, Message } from '@arco-design/web-vue';
import { activityDetailStore } from '@client/store/activityDetailStore';

const isMyself = computed(() => activityDetailStoreRef.isMyself);
const sportNote = computed(() => activityDetailStoreRef.sportNote);
const oldSportNote = computed(() => activityDetailStoreRef.oldSportNote);
const activityDetailStoreRef = activityDetailStore();
const vm = getCurrentInstance();
Message._context = vm?.appContext;
const t = vm.proxy.$root.$t;

async function handleSave() {
  const res = await activityDetailStoreRef.saveTrainingNoteAndFeeling();
  if (res) Message.success(t('R4030'));
}
</script>

<style lang="scss" scoped>
@import '@client/styles/_mixins.scss';
.training-note {
  height: 100%;
  padding: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  .training-note-input {
    flex-grow: 1;
    flex-shrink: 1;
    height: 160px;
    font-size: 14px;
  }

  .btn-group {
    flex-grow: 0;
    flex-shrink: 0;
    padding-top: 16px;
    text-align: right;

    button {
      min-width: 88px;
      height: 32px;
      padding: 0 16px;
      border-radius: 2px;
      border: 1px solid rgba(0, 0, 0, 0);
      background-color: #00b3ff;
      font-size: 14px;
      font-weight: 400;
      color: #ffffff;
      box-sizing: border-box;
      transition: background-color ease-in-out 0.2s;

      &[disabled] {
        color: rgba(255, 255, 255, 0.4);
        background-color: rgba(255, 255, 255, 0.1);
      }
    }
  }
}
</style>
